import { axiosGet } from '@/api/AxiosApi';

/**
 * 에러 함수명, 어느 조건(db, 컨트랙트, 예외처리 조건 실패 등등), 전달 값, 받은 값, 에러내용
 * ex)
 *    - type: 'server' | 'admin' | 'user'
 *    - call: StakingSettingService.create
 *    - method: findFactoryIdByContractAddr()
 *    - req: createStakingSettingDto.factory_id
 *    - res: factory
 *    - msg: 123
 *
 */
export const telegramForm = (text: string) => {
  const payload = {
    project: process.env.NODE_ENV === 'production' ? 'assetfi.ecpay.io/' : 'assetfidev1116.ecpay.io',
    value: {
      error: text,
    },
  };
  telegramBot(JSON.stringify(payload));
};

const telegramBot = (text: any) => {
  const payload = {
    apiUrl: 'https://api.telegram.org',
    path: `/bot${process.env.REACT_APP_TELEGRAM_BOT}/sendmessage?chat_id=${process.env.REACT_APP_TELEGRAM_BOT_ID}&text=${text}`,
  };

  axiosGet(payload);
};
